export const colors = {
  transparent: { value: 'transparent' },
  current: { value: 'currentColor' },
  black: { value: '#000000' },
  white: { value: '#FFFFFF' },
  neutral: {
    0: { value: '#ffffff' },
    50: { value: '#f6f6f6' },
    100: { value: '#e7e7e7' },
    200: { value: '#d1d1d1' },
    250: { value: '#888888' },
    300: { value: '#595959' },
    350: { value: '#454545' },
    400: { value: '#3d3d3d' },
    500: { value: '#000000' },
  },
  brand: {
    50: { value: '#f4f9f8' },
    100: { value: '#dbece7' },
    200: { value: '#b7d8d1' },
    300: { value: '#8bbdb3' },
    400: { value: '#49837a' },
    500: { value: '#396862' },
    600: { value: '#2a4542' },
    700: { value: '#213331' },
    800: { value: '#122120' },
    900: { value: '#122120' },
  },
  neonGreen: {
    50: { value: '#eefce9' },
    100: { value: '#dff8d7' },
    200: { value: '#c8f2ba' },
    300: { value: '#c0f1b0' },
    400: { value: '#b8efa6' },
    500: { value: '#b0ed9c' },
    600: { value: '#9ED58C' },
    700: { value: '#8DBE7D' },
    800: { value: '#7BA66D' },
    900: { value: '#58774E' },
  },
  purple: {
    50: { value: '#faf6fe' },
    100: { value: '#f3eafd' },
    200: { value: '#e8d8fc' },
    300: { value: '#d7baf8' },
    400: { value: '#c69cf4' },
    500: { value: '#a562ea' },
    600: { value: '#8f42db' },
    700: { value: '#7a30c0' },
    800: { value: '#672c9d' },
    900: { value: '#55257e' },
    950: { value: '#380e5d' },
  },
  red: {
    50: { value: '#fff0f0' },
    100: { value: '#ffdede' },
    200: { value: '#ffc3c3' },
    300: { value: '#ff9999' },
    400: { value: '#ff5e5e' },
    500: { value: '#ff2c2c' },
    600: { value: '#f61515' },
    700: { value: '#cf0606' },
    800: { value: '#ab0909' },
    900: { value: '#8d0f0f' },
    950: { value: '#4d0202' },
  },
  orange: {
    50: { value: '#fef8ee' },
    100: { value: '#fcefd8' },
    200: { value: '#f9daaf' },
    300: { value: '#f5bf7c' },
    400: { value: '#f09a47' },
    500: { value: '#ed8936' },
    600: { value: '#dd6519' },
    700: { value: '#b74d17' },
    800: { value: '#923d1a' },
    900: { value: '#763418' },
    950: { value: '#3f180b' },
  },
  green: {
    50: { value: '#effde8' },
    100: { value: '#dcf9ce' },
    200: { value: '#baf4a2' },
    300: { value: '#8fea6c' },
    400: { value: '#69dc3f' },
    500: { value: '#48c020' },
    600: { value: '#359b15' },
    700: { value: '#2a7615' },
    800: { value: '#255d17' },
    900: { value: '#234f18' },
    950: { value: '#0d2c07' },
  },
  blue: {
    50: { value: '#eff6ff' },
    100: { value: '#dbeafe' },
    200: { value: '#c0dbfd' },
    300: { value: '#94c5fc' },
    400: { value: '#62a5f8' },
    500: { value: '#4285f4' },
    600: { value: '#2763e9' },
    700: { value: '#1f4ed6' },
    800: { value: '#2041ad' },
    900: { value: '#1f3b89' },
    950: { value: '#182553' },
  },
};
